import PropTypes from 'prop-types';

export const ServicePropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number,
    priceLabel: PropTypes.string.isRequired,
    location: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    categoryName: PropTypes.string,
    wishlistId: PropTypes.string,
    badges: PropTypes.shape({
        isShowBCAAMember: PropTypes.bool,
        isNewService: PropTypes.bool,
        isTopRated: PropTypes.bool,
        isPromoted: PropTypes.bool
    }),
    verifications: PropTypes.shape({
        isCriminalRecordVerified: PropTypes.bool,
        isGovIdVerified: PropTypes.bool
    }),
    isFavorited: PropTypes.bool,
    ratings: PropTypes.number,
    ratingsCount: PropTypes.number
});
